// extracted by mini-css-extract-plugin
module.exports = {"view":"index_view-1xho3","content":"index_content-3OKON","left":"index_left-1CIgv","right":"index_right-3If-v","close":"index_close-zRMYU","download":"index_download-23vcL"};